module.exports = "pegasus/assets/blocks/image-4-theme5.png";